var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPot3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "115px",
    viewBox: "0 0 57 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pot5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.6694733%",
    y1: "-6.66432423%",
    x2: "68.6694733%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE62BE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB3A8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.2628091,0.0225132743 L24.5894014,0.0225132743 C25.7028075,0.0225132743 26.6054014,0.925107219 26.6054014,2.03851327 C26.6054014,2.09895585 26.6026832,2.15936785 26.597255,2.21956618 L22.1860931,51.1387874 C22.0924012,52.1778184 21.2214862,52.9737345 20.1782396,52.9737345 L6.67397097,52.9737345 C5.63072433,52.9737345 4.75980931,52.1778184 4.66611743,51.1387874 L0.254955561,2.21956618 C0.154962804,1.11065929 0.97284931,0.130652489 2.0817562,0.0306597322 C2.14195453,0.0252315063 2.20236653,0.0225132743 2.2628091,0.0225132743 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    transform: "translate(-1146.000000, -398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing-Card",
    transform: "translate(383.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enterprise",
    transform: "translate(640.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pot5",
    transform: "translate(123.500000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33706867,41.3845196 C10.3956502,41.4819788 16.0948064,47.1791293 16.1947502,54.2376761 L16.2643473,59.1529804 L16.2643473,59.1529804 C9.20576575,59.0555212 3.50660956,53.3583707 3.40666575,46.2998239 L3.33706867,41.3845196 L3.33706867,41.3845196 Z",
    id: "Rectangle",
    fill: "#65E09C",
    transform: "translate(9.800708, 50.268750) rotate(-24.000000) translate(-9.800708, -50.268750) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46127812,47.7168366 C15.8722799,52.0730928 20.029525,56.9276514 21.9452987,62.2793085 C23.8704428,67.6571415 24.6591856,76.6722338 24.3009625,89.3067519 C24.2954155,89.5023949 24.4556008,89.6653255 24.6587463,89.6708023 C24.8618918,89.6760098 25.0310705,89.5217405 25.0366175,89.3260975 C25.3970681,76.6130172 24.6020643,67.5263642 22.6410414,62.048305 C20.6706482,56.54407 16.4147208,51.5742766 9.88554448,47.1377212 C9.7194936,47.0248901 9.48990751,47.0630619 9.37274959,47.2229802 C9.25559167,47.3828985 9.29522724,47.6040055 9.46127812,47.7168366 Z",
    id: "Path",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7212325,38.2332624 C45.7220726,38.3329518 51.3738893,43.982799 51.4760188,50.9836039 L51.5542581,56.3467759 L51.5542581,56.3467759 C44.553418,56.2470865 38.9016013,50.5972394 38.7994718,43.5964345 L38.7212325,38.2332624 L38.7212325,38.2332624 Z",
    id: "Rectangle",
    fill: "#65E09C",
    transform: "translate(45.137745, 47.290019) scale(-1, 1) rotate(-25.000000) translate(-45.137745, -47.290019) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-88",
    transform: "translate(16.193848, 53.149053) rotate(-12.000000) translate(-16.193848, -53.149053) translate(9.193848, 27.649053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.385529708,0.458506688 C6.61764767,0.458506688 11.6697775,5.51063651 11.6697775,11.7427545 L11.6697775,16.0510067 L11.6697775,16.0510067 C5.43765953,16.0510067 0.385529708,10.9988769 0.385529708,4.7667589 L0.385529708,0.458506688 L0.385529708,0.458506688 Z",
    id: "Rectangle",
    fill: "#65E09C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95195889,5.02602234 C7.86549831,9.0222321 10.2390213,12.9565611 11.0815987,16.8268554 L11.1321984,17.0698998 L11.180947,17.3248345 C11.9703887,21.6241779 12.4273051,32.5582582 12.5456345,50.0843491 C12.5469559,50.2800608 12.7127669,50.4376849 12.9159839,50.43642 C13.1192008,50.4351398 13.2828695,50.2754524 13.2815561,50.0797407 L13.2649517,47.9173251 L13.2403773,45.4135252 C13.0686372,29.8707697 12.590864,20.3055964 11.8018671,16.6814187 C10.9287819,12.67099 8.48758129,8.62447912 4.48733626,4.53973215 C4.34790134,4.39735179 4.11501871,4.39078946 3.96717833,4.52507479 C3.81933796,4.65936012 3.81252398,4.88364197 3.95195889,5.02602234 Z",
    id: "Path",
    fill: "#28C76F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.2295293,26.2808076 C39.9523167,26.2851402 45.4011777,31.7338666 45.4056763,38.4566539 L45.4091398,43.632602 L45.4091398,43.632602 C38.6863523,43.6282694 33.2374914,38.1795431 33.2329928,31.4567557 L33.2295293,26.2808076 L33.2295293,26.2808076 Z",
    id: "Rectangle",
    fill: "#65E09C",
    transform: "translate(39.319335, 34.956705) scale(-1, 1) rotate(-1.000000) translate(-39.319335, -34.956705) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.150596,28.6899966 C36.8287838,34.7459259 33.6710039,40.5911824 31.678472,46.226569 C29.6894135,51.8521319 27.7055157,60.5397517 25.7234692,72.2961759 C25.6908995,72.4893619 25.8271103,72.671398 26.0277047,72.7027649 C26.228299,72.7341317 26.4173158,72.6029514 26.4498855,72.4097654 L26.6935047,70.9802913 L26.8606946,70.0172629 C28.6997821,59.5044617 30.5388132,51.6485704 32.3751199,46.4550284 C34.3446824,40.8846049 37.4716009,35.0964751 41.757091,29.0914419 C41.8721982,28.9301483 41.8297425,28.7095273 41.6622635,28.5986713 C41.4947845,28.4878152 41.2657032,28.5287029 41.150596,28.6899966 Z",
    id: "Path",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-87",
    transform: "translate(25.756949, 10.323750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03232494,14.3996261 C3.69580038,20.755473 2.01114183,28.6146294 0.978349278,37.9770954 C-0.0544432723,47.3395613 -0.269536707,56.7020273 0.333068973,66.0644932 L2.0432988,66.2130068 C1.43098836,55.2856483 1.49255641,45.8944039 2.22800293,38.0392736 C2.96344946,30.1841434 4.5165951,22.3290132 6.88743985,14.4738829 L6.03232494,14.3996261 Z",
    id: "Path",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73782454,17.956016 C10.8470755,17.9290025 13.3895199,15.4688873 13.4165332,12.4611949 C13.4435465,9.45350255 9.13526647,1.37066321 7.88668666,1.38150011 C6.63810684,1.39235881 2.18395282,9.55132716 2.15693956,12.5590195 C2.12992629,15.5667119 4.62857361,17.9830295 7.73782454,17.956016 Z",
    id: "Oval",
    fill: "#65E09C",
    transform: "translate(7.786691, 9.668870) rotate(14.000000) translate(-7.786691, -9.668870) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87893247,15.5746337 C10.0418894,15.5558417 11.8109543,13.7990254 11.8302495,11.6506747 C11.8495447,9.50232405 8.60641572,4.76377438 7.73783854,4.77131167 C6.86926137,4.77886697 4.01678467,9.57037592 3.99748948,11.7187266 C3.9781943,13.8670773 5.71597552,15.5934257 7.87893247,15.5746337 Z",
    id: "Oval",
    fill: "#28C76F",
    transform: "translate(7.913833, 10.173049) rotate(14.000000) translate(-7.913833, -10.173049) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44722493,14.9108653 L10.6007324,5.51317131 C10.7882099,4.95447387 10.4699083,4.35519245 9.88978593,4.1746388 C9.30966351,3.99408515 8.6874008,4.30063125 8.49992327,4.85932869 L5.34641583,14.2570227 C5.15893829,14.8157201 5.47723985,15.4150016 6.05736227,15.5955552 C6.63748469,15.7761089 7.2597474,15.4695627 7.44722493,14.9108653 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-87",
    transform: "translate(14.861037, 34.468868) scale(-1, 1) rotate(6.000000) translate(-14.861037, -34.468868) translate(6.861037, 0.968868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03232494,14.3996261 C3.69580038,20.755473 2.01114183,28.6146294 0.978349278,37.9770954 C-0.0544432723,47.3395613 -0.269536707,56.7020273 0.333068973,66.0644932 L2.0432988,66.2130068 C1.43098836,55.2856483 1.49255641,45.8944039 2.22800293,38.0392736 C2.96344946,30.1841434 4.5165951,22.3290132 6.88743985,14.4738829 L6.03232494,14.3996261 Z",
    id: "Path",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73782454,17.956016 C10.8470755,17.9290025 13.3895199,15.4688873 13.4165332,12.4611949 C13.4435465,9.45350255 9.13526647,1.37066321 7.88668666,1.38150011 C6.63810684,1.39235881 2.18395282,9.55132716 2.15693956,12.5590195 C2.12992629,15.5667119 4.62857361,17.9830295 7.73782454,17.956016 Z",
    id: "Oval",
    fill: "#65E09C",
    transform: "translate(7.786691, 9.668870) rotate(14.000000) translate(-7.786691, -9.668870) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87893247,15.5746337 C10.0418894,15.5558417 11.8109543,13.7990254 11.8302495,11.6506747 C11.8495447,9.50232405 8.60641572,4.76377438 7.73783854,4.77131167 C6.86926137,4.77886697 4.01678467,9.57037592 3.99748948,11.7187266 C3.9781943,13.8670773 5.71597552,15.5934257 7.87893247,15.5746337 Z",
    id: "Oval",
    fill: "#28C76F",
    transform: "translate(7.913833, 10.173049) rotate(14.000000) translate(-7.913833, -10.173049) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44722493,14.9108653 L10.6007324,5.51317131 C10.7882099,4.95447387 10.4699083,4.35519245 9.88978593,4.1746388 C9.30966351,3.99408515 8.6874008,4.30063125 8.49992327,4.85932869 L5.34641583,14.2570227 C5.15893829,14.8157201 5.47723985,15.4150016 6.05736227,15.5955552 C6.63748469,15.7761089 7.2597474,15.4695627 7.44722493,14.9108653 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.3071265,43.2989685 C42.5817668,46.5593007 36.4976293,50.3269812 33.0574866,54.6161326 C29.6176437,58.9049102 27.3446886,65.5562705 26.2236243,74.5716118 C26.1994595,74.7659391 26.3434447,74.9423385 26.5452241,74.9656108 C26.7470035,74.9888831 26.9301675,74.8502156 26.9543322,74.6558882 C28.0609947,65.7563631 30.2945159,59.2203987 33.6398986,55.0493935 C36.9849815,50.8787621 42.9618665,47.1774991 51.573326,43.9597271 C51.7627865,43.888933 51.8567839,43.6836271 51.7832749,43.5011637 C51.7097659,43.3187002 51.496587,43.2281744 51.3071265,43.2989685 Z",
    id: "Path",
    fill: "#28C76F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,69 C26.8058985,60.3825138 20.1392318,57.3346077 9.5,59.8562818 C17.4655583,62.192919 23.479486,65.2408251 27.541783,69 L29.5,69 Z",
    id: "Path-151",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,67 C44.5768196,57.8301698 38.2434863,53.9157012 28.5,55.2565943 C34.4177255,59.5385457 40.0428176,63.4530143 45.3752763,67 L47.5,67 Z",
    id: "Path-151",
    fill: "#28C76F",
    transform: "translate(38.000000, 61.000000) scale(-1, 1) translate(-38.000000, -61.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8616655,68.6079488 C25.6772957,59.9705722 30.1066676,53.4174029 38.1497813,48.948441 C34.1894805,57.9680267 30.3378416,64.4271888 26.5948643,68.3259271 L24.8616655,68.6079488 Z",
    id: "Path-151",
    fill: "#28C76F",
    transform: "translate(31.505723, 58.778195) rotate(-22.000000) translate(-31.505723, -58.778195) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1489721,68 C23.4522307,63.2008554 21.7644705,56.4977557 20.5,50 C26.7506145,52.4604821 28.7583518,62.263006 26.7506145,68 L25.1489721,68 Z",
    id: "Path-114",
    fill: "#65E09C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.500000, 62.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#35a3c6",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.31578947,-0.938053097 L6.55858074,-0.938053097 C0.439592516,21.5752212 18.8599747,30.9557522 6.55858074,53.4690265 L-3.31578947,53.4690265 L-3.31578947,-0.938053097 Z",
    id: "Rectangle",
    fill: "#8B81EB",
    mask: "url(#mask-3)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPot3);
export default __webpack_public_path__ + "static/media/Pot3.cb154f35a5586a20cf144d23a9d8d776.svg";
export { ForwardRef as ReactComponent };